import { useAppSelector } from "../../../lib/redux/hooks"

export function TuttiProvvedimentiList() {
    const newMeasureState = useAppSelector(state => state.newMeasure)
    const measures = newMeasureState.getAllNewMeasureResponse?.data || []

    return (
        <div className="w-full p-4">
            <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                <table id="users-table" className="w-full border-collapse text-sm min-w-[1200px]">
                    <thead>
                        <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">SOT</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Regione</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Ragione Sociale</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cod Op</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Inizio</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Fine</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Scadenza</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Protocollo</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Codice Nc</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Tipo Provvedimento</th>
                            <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tr-xl">Stato</th>
                        </tr>
                    </thead>
                    <tbody>
                        {measures.length === 0 ? (
                            <tr>
                                <td colSpan={11} className="px-3 py-4 text-center text-neutral-500 bg-white">
                                    Nessun provvedimento trovato
                                </td>
                            </tr>
                        ) : (
                            measures.map((measure, index) => (
                                <tr
                                    key={index}
                                    className={`border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                >
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{measure.customerHeadQuarters || '-'}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{measure.customerCountryRegion || '-'}</td>
                                    <td className="px-3 py-2 text-neutral-700">{measure.customerCompanyName || '-'}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{measure.customerClientCode || '-'}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{measure.customerStartingDate || '-'}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{measure.customerEndingDate || '-'}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{measure.customerEndingDate || '-'}</td>
                                    <td className="px-3 py-2 text-neutral-700">{measure.departureProtocolInfo || '-'}</td>
                                    <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{measure.oldNonComplianceCode || '-'}</td>
                                    <td className="px-3 py-2 text-neutral-700">{measure.customerEndingDate || '-'}</td>
                                    <td className="px-3 py-2 whitespace-nowrap">
                                        <span className="inline-flex rounded-full border border-neutral-300 bg-white px-2.5 py-1 text-xs font-semibold text-neutral-700">
                                            {measure.status || '-'}
                                        </span>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}